import { applyMiddleware, createStore } from "redux";
import tank from "redux-thunk";
import reducer from "./index";

import {
  campaignsDateRangeStorage,
  widgetDateRangeStorage,
  teaserListDateRangeStorage,
  overviewDateRangeStorage,
  paymentsDateRangeStorage,
  wmPaymentsDateRangeStorage
} from "../utils";

const createStoreWithMiddleware = applyMiddleware(tank)(createStore);

const initial = {
  overview: { dateRange: overviewDateRangeStorage.get() },
  campaignList: { dateRange: campaignsDateRangeStorage.get() },
  widgetList: {
    dateRange: widgetDateRangeStorage.get()
  },
  teaserList: { dateRange: teaserListDateRangeStorage.get() },
  payments: { dateRange: paymentsDateRangeStorage.get() },
  wmPayments: { dateRange: wmPaymentsDateRangeStorage.get() },
  closeMenu:
    window.offsetWidth < 1275 || localStorage.getItem("size") === "sm"
      ? true
      : false,

  payment: {},
  campaignDropDown: {},
  notifications: []
};

export default createStoreWithMiddleware(
  reducer,
  initial,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
